import React, { FC } from 'react'
import { FormModelComponent } from 'Pages/landings/newLandings/common/components'
import { Wrapper, TitleModel, SubTitleModel } from './styled'

interface ComponentProps {
	className?: string
}

export const FormComponent: FC<ComponentProps> = ({ className }) => {
	return (
		<Wrapper id="form" className={className}>
			<FormModelComponent isInn isKnowInn isProduct>
				<TitleModel>
					Станьте самозанятым
					<br />
					через СберБанк Онлайн
				</TitleModel>
				<SubTitleModel>
					Или подключите бесплатный сервис «Своё дело», если вы уже зарегистрированы в&nbsp;статусе
					самозанятого
				</SubTitleModel>
			</FormModelComponent>
		</Wrapper>
	)
}
